/**
 * Configuration runtime du frontend — production.
 * L'API Worker est la seule source de données (plus de mode mock).
 */

export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api/v1',
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? '',
  isDev: import.meta.env.DEV,
} as const;
